/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { n as navigate } from '../../../index-ee2c9aee.js';
import '../../../index-892d8eee.js';

function redirectTo(params) {
    navigate.replace({
        url: params.url,
        isHash: params.isHash,
        refresh: params.refresh,
    });
}

export { redirectTo as default };
